import { render, staticRenderFns } from "./TabContainer.vue?vue&type=template&id=af00854a&scoped=true"
import script from "./TabContainer.vue?vue&type=script&lang=js"
export * from "./TabContainer.vue?vue&type=script&lang=js"
import style0 from "./TabContainer.vue?vue&type=style&index=0&id=af00854a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af00854a",
  null
  
)

export default component.exports